import { API_ROUTES } from "@/lib/config/api-routes";
import { ApiService } from "@/lib/services/api-service";
import type {
  BookingRentalDataApiResponse,
  BookingRentalDataQueryParams,
} from "@/lib/types/booking-rental";

class BookingRentalService extends ApiService {
  fetchBookingRentalData(params: BookingRentalDataQueryParams) {
    return this.get<BookingRentalDataApiResponse>(API_ROUTES.bookingRentalData, {
      params,
    });
  }
}

export const bookingRentalService = new BookingRentalService();
